
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 122.88 122.88"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M75.56 1.66a61.42 61.42 0 1045.66 73.9 61.42 61.42 0 00-45.66-73.9z","fill":"#5f259f"}}),_c('path',{attrs:{"d":"M89.32 45.41A4.54 4.54 0 0084.86 41h-8.24L57.75 19.33a7 7 0 00-7.21-2.06L44 19.33a1.52 1.52 0 00-.69 2.4l20.61 19.56H32.7A1.63 1.63 0 0031 43v3.43a4.54 4.54 0 004.46 4.46h4.81v16.48c0 12.35 6.52 19.56 17.5 19.56a23.66 23.66 0 009.61-1.72v11a5.42 5.42 0 005.49 5.49h4.8a2.22 2.22 0 002.06-2.06V50.56h7.87a1.63 1.63 0 001.72-1.72v-3.43zm-22 29.51a16.38 16.38 0 01-6.87 1.37c-5.49 0-8.23-2.74-8.23-8.92V50.9h15.1v24z","fill":"#fff"}})])
          )
        }
      }
    